import { useGLTF, Edges, PresentationControls, Center, Text, Image } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import React, { useRef } from "react";
import * as THREE from 'three'
import { __ } from "../../../utils";
import { mainStore } from "../../../store";


const material = new THREE.MeshStandardMaterial({
    color: '#ffffef',
    side: THREE.DoubleSide
})


export const Autophagy = React.forwardRef((props, ref) => {

    const { nodes } = useGLTF(import.meta.env.BASE_URL + 'static/models/autophagy.glb')

    const colors = mainStore.useStore(s => s.colors)
    const fonts = mainStore.useStore(s => s.fonts)


    return <>
        {/* <Text

            anchorX={'0%'}
            anchorY={'0%'}
            fontSize={0.06}
            fillOpacity={.5}
            position={[-0.6, -2.6, -0.3]}
            rotation={[0, 0, 0.8]}
            font={fonts.ms.italic}
            color={colors.title}
            textAlign="left"
        >
            {
                __('Tournez-moi', 'Slide me')
            }
        </Text> */}
        <mesh receiveShadow castShadow {...props} ref={ref} dispose={null} geometry={nodes.autophagosome.geometry} material={material}>
            <Edges
                geometry={nodes.autophagosome.geometry}
                lineWidth={0.7}
                threshold={0.5}
                color="black"
                scale={1}
                opacity={.8}
                depthTest={true}
                depthWrite={false}
                renderOrder={1000}
                polygonOffset={false}
                polygonOffsetFactor={10}
            />
        </mesh>

    </>




})

useGLTF.preload(import.meta.env.BASE_URL + 'static/models/autophagy.glb')